import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/permissions.service";
import * as i2 from "@angular/router";
var CanLoadGuard = /** @class */ (function () {
    function CanLoadGuard(permService, router) {
        this.permService = permService;
        this.router = router;
    }
    CanLoadGuard.prototype.canLoad = function (route, segments) {
        var permissionRequired = route.data["permissionRequired"];
        if (this.permService.authorizeUser(permissionRequired)) {
            return true;
        }
        else {
            this.router.navigateByUrl("/landing/dashboard/401");
            return false;
        }
    };
    CanLoadGuard.ngInjectableDef = i0.defineInjectable({ factory: function CanLoadGuard_Factory() { return new CanLoadGuard(i0.inject(i1.PermissionsService), i0.inject(i2.Router)); }, token: CanLoadGuard, providedIn: "root" });
    return CanLoadGuard;
}());
export { CanLoadGuard };
